/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, orderNumber: NonNullable<unknown> }} Orders_Delete_Document_Confirm_DescriptionInputs */

const en_orders_delete_document_confirm_description = /** @type {(inputs: Orders_Delete_Document_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.label}" will be permanently removed from order ${i?.orderNumber}. This cannot be undone.`)
};

const es_orders_delete_document_confirm_description = /** @type {(inputs: Orders_Delete_Document_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.label}" se eliminará permanentemente del pedido ${i?.orderNumber}. Esto no se puede deshacer.`)
};

/**
* | output |
* | --- |
* | "\"{label}\" will be permanently removed from order {orderNumber}. This cannot be undone." |
*
* @param {Orders_Delete_Document_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delete_document_confirm_description = /** @type {((inputs: Orders_Delete_Document_Confirm_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delete_Document_Confirm_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delete_document_confirm_description(inputs)
	return es_orders_delete_document_confirm_description(inputs)
});